import React from "react";
import { Spin } from "antd";

const CustomSpin = (props) => (
  <Spin className={` ${props.className != null ? props.className : ""}`} {...props}>
    {props.children}
  </Spin>
);
export default CustomSpin;
